"use strict";
exports.__esModule = true;
exports.Guards = void 0;
var Guards = /** @class */ (function () {
    function Guards() {
    }
    Guards.ensureOneOrDefaultValue = function (argument, defaultValue) {
        if (argument === undefined || argument === null) {
            return defaultValue;
        }
        return argument;
    };
    Guards.ensureOneOrException = function (argument, missingExceptionBlock) {
        if (argument === undefined || argument === null) {
            throw missingExceptionBlock;
        }
        return argument;
    };
    return Guards;
}());
exports.Guards = Guards;
